import {PRODUCT_UPDATED, COUPON_UPDATED, STORE_CLOSE_EVENT} from '../actions/liveEvents';

const initialState = {
    productUpdated: false,
    couponUpdated: false,
    storeCloseEvent: false
}

const liveEvent = (state = initialState, action) => {
    switch(action.type) {
        case PRODUCT_UPDATED:
            return {...state, productUpdated: action.data};
        case COUPON_UPDATED:
            return {...state, couponUpdated: action.data};
        case STORE_CLOSE_EVENT:
            return {...state, storeCloseEvent: action.data};
        default:
            return state;
    }
}

export default liveEvent;